import axios from "axios";
import { logout } from "../lib/auth";
import { followCallTableColumn } from "../config/followCall";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// フォローコール一覧
export async function getFollowCalls(
  props: { [key: string]: number | string },
  sortColumn: {
    key: string;
    sort: string;
  }[]
) {
  try {
    const path = "followCalls";
    const params = makeParams(followCallTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params: { ...params, sortColumn },
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const followCalls: dataDifine[] = response.data.fetch_data;
    const countFollowCalls: string = response.data.count_data;
    return { followCalls, countFollowCalls };
  } catch (error) {
    // logout();
  }
}

// フォローコール停止・再開
export async function putFollowCallStatus(id: string, startStop: string) {
  try {
    const path = "followCall/status";
    const params = { id };
    const bodys = { id, startStop };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// フォローコール実施
export async function putFollowCallCall(
  id: string,
  follow_call_status: number | null,
  follow_call_hope_date: string,
  follow_call_hope_time: string,
  follow_call_memo: string
) {
  try {
    const path = "followCall/call";
    const params = { id };
    const bodys = {
      id,
      follow_call_status,
      follow_call_hope_date,
      follow_call_hope_time,
      follow_call_memo,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}
